module.exports = __webpack_public_path__ + "f25b8d7cd948b7ac0f8edf0959fbf9a8.png";